import React from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'
import { compose } from 'redux'
import config from 'config'

import { withSnowplowContexts, SnowplowContext } from '@cred/react-analytics/SnowplowContextManager'
import { creditMonitoring } from '@cred/react-analytics/contexts'

import WidgetPage from 'components/hocs/widget-page'
import SimpleCtaMonitoring from 'components/simple-cta-insurance-and-monitoring'
import SimpleCta from 'components/simple-cta'

const variations = {
  'learn-more': 'Learn More',
  'get-credit-monitoring': 'Get Credit Monitoring',
  'get-free-credit-monitoring': 'Get Free Credit Monitoring',
  'monitor-my-credit': 'Monitor My Credit',
  'visit-experian': 'Visit Experian',
}
const SimpleCtaApp = (props) => {
  const { variation } = props
  const [trackingId, setTrackingId] = React.useState(uuid())

  const partnerHref = (partner) => {
    const urls = {
      Experian: `https://ecdtrk.com/?a=151&oc=533&c=7254&m=26&s1=&s2=${trackingId}`,
    }

    return urls[partner]
  }

  const onClickHandle = (name) => {
    setTrackingId(uuid())

    window.open(partnerHref(name), '_blank')
  }

  switch (variation) {
    case 'visit-experian':
      return (
        <SnowplowContext
          contexts={[
            creditMonitoring.analytics({
              providerName: 'Experian',
              type: 'credit-monitoring',
              trackingId,
            }),
          ]}
        >
          <SimpleCtaMonitoring
            variations={variations}
            onClickHandle={() => onClickHandle('Experian')}
            {...props}
          />
        </SnowplowContext>
      )
    default:
      return (
        <SimpleCta
          url={`${config.credibleRoot}/blog/banking/credit-monitoring-services`}
          variations={variations}
          large={variations[variation]?.length > 20}
          {...props}
        />
      )
  }
}

SimpleCtaApp.propTypes = {
  variation: PropTypes.string.isRequired,
  spContexts: PropTypes.array,
  trackSnowplowEvent: PropTypes.func,
}

export default compose(WidgetPage, withSnowplowContexts)(SimpleCtaApp)
